import moment from "moment";

import "moment/locale/en-gb";
import "moment/locale/nl";
import "moment/locale/nl-be";
import "moment/locale/fr";

const intializeMoment = (locale) => {
  moment.updateLocale("en", {
    longDateFormat: {
      L: "MM-DD-YYYY",
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      LL: "MMMM D YYYY",
      LLL: "MMMM D YYYY HH:mm",
      LLLL: "dddd, MMMM D YYYY HH:mm",
    },
  });
  moment.updateLocale("en-gb", {
    longDateFormat: {
      L: "DD-MM-YYYY",
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm",
    },
  });
  moment.updateLocale("nl-be", {
    longDateFormat: {
      L: "DD-MM-YYYY",
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
  });
  moment.defineLocale("fr-fr", {
    parentLocale: "fr",
    longDateFormat: {
      L: "DD-MM-YYYY",
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
  });
  moment.defineLocale("nl-nl", {
    parentLocale: "nl",
    longDateFormat: {
      L: "DD-MM-YYYY",
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
  });

  moment.locale(locale ? locale.toLowerCase() : "en");
};

export default intializeMoment;
